var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuringTravel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.064 11.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.241,2.63c.576-.169.806-1.148.616-1.82A1.035,1.035,0,0,0,3.512.05a1.059,1.059,0,0,0-.741,1.373c.19.672.894,1.376,1.47,1.207",
    transform: "translate(0 0)",
    fill: "var(--primary-color)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05,2.986c-.889.339-.511,1.4-.035,2.587a.488.488,0,0,0,.055.012l2.544.258a20.621,20.621,0,0,0-1.587-2.8,1.086,1.086,0,0,0-.977-.058",
    transform: "translate(0 0)",
    fill: "var(--primary-color)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.97,10.688,10.64,6.757a.761.761,0,0,0-.572-.342C9.843,6.4,8.12,6.186,7.232,6.077a1.335,1.335,0,0,1,.431.555l0,0,.309.763.914.053a1.073,1.073,0,0,1,.915.556l.367.736L12,11.317a.574.574,0,0,0,.483.262.567.567,0,0,0,.314-.094.575.575,0,0,0,.169-.8",
    fill: "var(--primary-color)",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.455,8.271a.753.753,0,0,0-.644-.393L7.683,7.812,7.3,6.857a.927.927,0,0,0-.727-.585l-2.6-.264a.82.82,0,0,1-.655-.566L2.46,3.2a.9.9,0,0,0-.841-.641H.592c-.325,0-.748.376-.533,1.049L2.011,9.768a.881.881,0,0,0,.854.61H9.712a.489.489,0,0,0,.43-.738Z",
    transform: "translate(0 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.318,11.3a.33.33,0,0,0,.332.331H8.885A.333.333,0,0,0,9.22,11.3v-.533h-5.9Z",
    transform: "translate(0 0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuringTravel);
export default __webpack_public_path__ + "static/media/duringTravel.60823ef3d75604e14e92eff6b2c14df1.svg";
export { ForwardRef as ReactComponent };